import styled from 'styled-components';

import ListItem from '../ListItem';

const DropDownItem = styled(ListItem)`
  list-style-type: none;
  line-height: 30px;
  white-space: nowrap;
  border-bottom: none;
  padding: 0;
  color: ${props => props.textColor || '#333'};
  button:hover,
  a:hover {
    color: ${props => props.hoverTextColor || '#00416f'};
    background-color: #f5f5f5;
  }
`;

export default DropDownItem;
